/* Script du thème : menu, panier coulissant, choix du set, galerie, étui qui s'ouvre.
   Sans JavaScript, le site reste utilisable : les formulaires envoient vers la page panier. */
(() => {
  const E = window.ETUI || {};
  const T = E.t || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = (cents) =>
    new Intl.NumberFormat(E.locale || 'fr', { style: 'currency', currency: E.currency || 'EUR', minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);

  /* ----- Message bref en bas d'écran ----- */
  const toastEl = $('#toast');
  function toast(text) {
    if (!toastEl) return;
    toastEl.textContent = text;
    toastEl.classList.add('on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('on'), 2600);
  }

  /* ----- Menu mobile ----- */
  function toggleMenu(force) {
    const on = force ?? !document.body.classList.contains('menu-on');
    const header = $('header.top');
    if (header) document.documentElement.style.setProperty('--mtop', header.getBoundingClientRect().bottom + 'px');
    document.body.classList.toggle('menu-on', on);
    $('[data-menu-toggle]')?.setAttribute('aria-expanded', on);
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }
  $('[data-menu-toggle]')?.addEventListener('click', () => toggleMenu());

  /* ----- Panier coulissant ----- */
  const drawer = $('#drawer');
  const jsonHeaders = { 'Content-Type': 'application/json', Accept: 'application/json' };

  async function fetchCart() {
    const res = await fetch(E.routes.cart + '.js', { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Panier indisponible');
    return res.json();
  }

  function renderCart(cart) {
    const n = cart.item_count;
    $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.classList.toggle('zero', !n); });
    if (!drawer) return;

    const progress = $('#cartProgress');
    if (E.tiersOn) {
      progress.hidden = false;
      // Textes traduits côté Liquid (layout/theme.liquid), le HTML vient des fichiers de langue
      progress.innerHTML = !n
        ? `<span>${esc(T.tierStart)}</span>`
        : n === 1
          ? `<span>${T.tierNext2}</span><div class="track2"><i style="width:50%"></i></div>`
          : `<span>${T.tierBest}</span><div class="track2"><i style="width:100%"></i></div>`;
    } else progress.hidden = true;

    $('#cartItems').innerHTML = n
      ? cart.items.map((item) => `
        <div class="cline">
          <a class="mini${/grav/i.test(item.product_type || '') ? ' metal' : ''}" href="${esc(item.url)}">${item.image ? `<img class="pimg" src="${esc(item.image)}" alt="" loading="lazy">` : ''}</a>
          <div>
            <b style="font-weight:500">${esc(item.product_title)}</b>
            <small class="mono">${esc(item.sku || '')}</small>
            <div class="qty">
              <button type="button" aria-label="${esc(T.removeOne)}" data-qty="${esc(item.key)}" data-to="${item.quantity - 1}">−</button>
              <span>${item.quantity}</span>
              <button type="button" aria-label="${esc(T.addOne)}" data-qty="${esc(item.key)}" data-to="${item.quantity + 1}">+</button>
            </div>
          </div>
          <div class="px">${item.final_line_price < item.original_line_price ? `<s>${money(item.original_line_price)}</s>` : ''}${money(item.final_line_price)}</div>
        </div>`).join('')
      : `<div style="padding:32px 0"><p class="mute">${esc(T.empty)}</p></div>`;

    const saved = cart.original_total_price - cart.total_price;
    $('#cartFoot').innerHTML = n
      ? `${saved > 0 ? `<div class="row red"><span>${esc(T.discount)}</span><span>-${money(saved)}</span></div>` : ''}
         <div class="row"><span>${esc(T.shipping)}</span><span>${esc(E.shipping || '')}</span></div>
         <div class="row t"><span>${esc(T.total)}</span><span>${money(cart.total_price)}</span></div>
         <form action="${esc(E.routes.cart)}" method="post"><button class="btn red full" type="submit" name="checkout">${esc(T.checkout)}</button></form>
         <div class="tick mono mute"><span>${esc(E.shipping || '')}</span><span>${esc(T.returns)}</span><span>${esc(T.securePayment)}</span></div>`
      : `<button class="btn full" type="button" data-cart-close>${esc(T.cont)}</button>`;
  }

  async function refreshCart() {
    try { renderCart(await fetchCart()); } catch (e) { /* le panier reste accessible par sa page */ }
  }
  function openCart() {
    if (!drawer) return;
    drawer.classList.add('on');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('on');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  async function addItems(items) {
    const res = await fetch(E.routes.add + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ items }) });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      toast(err.description || err.message || T.addError);
      return false;
    }
    await refreshCart();
    openCart();
    return true;
  }
  async function changeQty(key, quantity) {
    const res = await fetch(E.routes.change + '.js', { method: 'POST', headers: jsonHeaders, body: JSON.stringify({ id: key, quantity }) });
    if (res.ok) renderCart(await res.json());
    else toast(T.qtyError);
  }

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-cart-open]');
    if (open && drawer) { e.preventDefault(); toggleMenu(false); refreshCart(); openCart(); return; }
    if (e.target.closest('[data-cart-close]')) { closeCart(); return; }
    const q = e.target.closest('[data-qty]');
    if (q) changeQty(q.dataset.qty, Number(q.dataset.to));
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); toggleMenu(false); } });

  /* Ajout rapide depuis une carte produit */
  document.addEventListener('submit', (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    addItems([{ id: Number(quick.elements.id.value), quantity: 1 }]);
  });

  /* ----- Fiche produit : choix du nombre d'étuis et des motifs ----- */
  const form = $('[data-product-form]');
  if (form) {
    // Le premier étui au prix normal, chaque étui suivant au prix réduit
    const t1 = Number(form.dataset.t1), t2 = Number(form.dataset.t2);
    const extras = {}; // emplacement (2 ou 3) -> identifiant de variante
    let n = 1;

    function paint() {
      const total = E.tiersOn ? t1 + (n - 1) * t2 : t1 * n;
      const full = t1 * n;
      $$('[data-total]').forEach((el) => { el.textContent = money(total); });
      const fullEl = $('[data-full]'), saveEl = $('[data-save]'), hint = $('[data-hint]');
      if (fullEl && saveEl) {
        fullEl.hidden = saveEl.hidden = !(n > 1 && full > total);
        fullEl.textContent = money(full);
        saveEl.textContent = '-' + money(full - total);
      }
      if (hint) hint.hidden = n > 1;
      $$('.seg button', form).forEach((b) => b.classList.toggle('on', Number(b.dataset.n) === n));
      $$('.slotrow', form).forEach((row) => {
        const slot = Number(row.dataset.slot);
        row.hidden = slot > n;
        if (!extras[slot]) {
          // Motif proposé par défaut : le premier pour l'étui 2, le deuxième pour l'étui 3
          const first = $$('.sw', row)[slot - 2] || $('.sw', row);
          if (first) extras[slot] = first.dataset.variant;
        }
        $$('.sw', row).forEach((sw) => {
          const on = sw.dataset.variant === extras[slot];
          sw.classList.toggle('on', on);
          if (on) $('[data-slot-name]', row).textContent = sw.dataset.name;
        });
      });
      const extra = $('[data-sticky-extra]');
      if (extra) extra.textContent = n > 1 ? ` + ${n - 1}` : '';
    }

    form.addEventListener('click', (e) => {
      const seg = e.target.closest('.seg button');
      if (seg) { n = Number(seg.dataset.n); paint(); return; }
      const sw = e.target.closest('.sw');
      if (sw) { extras[Number(sw.closest('.slotrow').dataset.slot)] = sw.dataset.variant; paint(); }
    });
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const items = [{ id: Number(form.elements.id.value), quantity: 1 }];
      for (let slot = 2; slot <= n; slot++) if (extras[slot]) items.push({ id: Number(extras[slot]), quantity: 1 });
      addItems(items);
    });
    paint();

    /* Barre d'achat collante quand le bouton principal sort de l'écran (mobile) */
    const atc = $('#atc'), sticky = $('#sticky');
    if (atc && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const on = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('on', on);
        sticky.setAttribute('aria-hidden', String(!on));
      }).observe(atc);
    }
  }

  /* ----- Galerie mobile : points sous les photos ----- */
  const gal = $('#gal'), dots = $$('#dots i');
  if (gal && dots.length) {
    gal.addEventListener('scroll', () => {
      const i = Math.round(gal.scrollLeft / gal.clientWidth);
      dots.forEach((d, k) => d.classList.toggle('on', k === i));
    }, { passive: true });
  }

  /* ----- Onglets d'une section collection ----- */
  $$('[data-tabs]').forEach((tabs) => {
    const scope = tabs.parentElement;
    tabs.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-tab]');
      if (!tab) return;
      $$('[data-tab]', tabs).forEach((b) => b.classList.toggle('on', b === tab));
      $$('[data-panel]', scope).forEach((p) => { p.hidden = p.dataset.panel !== tab.dataset.tab; });
    });
  });

  /* ----- Tri d'une collection ----- */
  $('[data-sort]')?.addEventListener('change', (e) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.target.value);
    url.searchParams.delete('page');
    location.href = url.toString();
  });

  /* ----- Étui qui s'ouvre : animation dessinée, ou vidéo si elle est renseignée ----- */
  const book = $('#book'), vid = $('#openVid'), bookBtn = $('#bookBtn');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function toggleBook(force) {
    if (vid) { vid.currentTime = 0; vid.play().catch(() => {}); return; }
    if (!book) return;
    const on = force ?? !book.classList.contains('on');
    book.classList.toggle('on', on);
    if (bookBtn) bookBtn.textContent = on ? bookBtn.dataset.closeLabel : bookBtn.dataset.openLabel;
  }
  bookBtn?.addEventListener('click', () => toggleBook());
  const target = vid || book;
  if (target && 'IntersectionObserver' in window) {
    if (vid && reduced) {
      vid.addEventListener('loadedmetadata', () => { vid.currentTime = Math.max(0, vid.duration - 0.05); }, { once: true });
    } else {
      const once = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        if (vid) vid.play().catch(() => {});
        else setTimeout(() => toggleBook(true), 350);
        once.disconnect();
      }), { threshold: 0.6 });
      once.observe(target);
    }
  }

  /* Le compteur du panier est à jour dès le chargement, même si la page vient du cache */
  if (drawer) refreshCart();
})();
